import { createElement, styled, compose, position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap } from '@vebox/etui-system';

const ButtonElement = createElement('button');
const Button = styled(ButtonElement)(compose(position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap));
Button.displayName = 'Button';

export { Button };
